
const props = {
    orderHistoryDatatableMarker: '.marker-order-history',
    orderHistoryDatatable: '#dt-order-history'
}; 

export function initDtAdminOrderHistory() {

    if ($(props.orderHistoryDatatableMarker).length) {
        dtAdminOrderHistory();
    }
}

function dtAdminOrderHistory() {

    if ($(props.orderHistoryDatatable).length === 0) return false;

    $(props.orderHistoryDatatable).DataTable({
        iDisplayLength: 100,
        paging: true,
        info: true,
        ordering: true,
        filter: false,
        lengthChange: false,
        serverSide: true,
        deferRender: true,
        ajax: {
            url: '/administration/ordermanagement/orderhistorysearch',
            data: function (d) {
                d.orderId = $(props.orderHistoryDatatable).data('id');
            },
            dataSrc: function (data) {

                if (data.responseType === 'SUCCESS')
                    return data.data;
                else
                    responseError(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus);
            },
            type: 'POST'
        },

        columns: [
            { data: 'actionDate', name: 'Date' },
            { data: 'action', name: 'Action' },
            { data: 'actionBy', name: 'By' },
            { data: 'actionNotes', name: 'Notes' }
        ],

        createdRow: function (row, data, dataIndex) {
            $(row).attr('data-id', data.id);
        }

    });
}
